import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';

import NotFoundPage from 'components/NotFoundPage';

import messages from './messages';

class AssetDetailData extends Component {
  static propTypes = {
    addPageToBreadcrumbs: PropTypes.func.isRequired,
    assetError: PropTypes.shape({
      error: PropTypes.oneOf([true]).isRequired,
    }),
    assetInfo: PropTypes.shape({
      id: PropTypes.string,
      unitNumber: PropTypes.string,
    }).isRequired,
    ChildComponent: PropTypes.func.isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: PropTypes.object.isRequired,
    i18n: PropTypes.shape({
      _: PropTypes.func.isRequired,
    }).isRequired,
    loadAsset: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        assetId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    setCurrentAsset: PropTypes.func.isRequired,
    setCurrentAssetCases: PropTypes.func.isRequired,
    setLoadingStarted: PropTypes.func.isRequired,
  };

  static defaultProps = {
    assetError: undefined,
  };

  componentWillMount() {
    const { match: { params: { assetId } } } = this.props;
    this.props.setCurrentAsset(assetId);
  }

  componentDidMount() {
    const {
      assetInfo,
      location: { pathname },
      match: { params: { assetId } },
    } = this.props;

    if (assetInfo.id) {
      this.props.addPageToBreadcrumbs({
        path: pathname,
        message: messages.breadcrumbs,
        number: assetInfo.unitNumber,
      });
    }

    this.props.loadAsset(assetId);
    this.props.setLoadingStarted();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.assetInfo.id && nextProps.assetInfo.id) {
      this.props.addPageToBreadcrumbs({
        path: this.props.location.pathname,
        message: messages.breadcrumbs,
        number: nextProps.assetInfo.unitNumber,
      });
    }
  }

  componentWillUnmount() {
    this.props.setCurrentAsset();
    this.props.setCurrentAssetCases({});
  }

  render() {
    const {
      assetError,
      ChildComponent,
      i18n,
    } = this.props;

    if (assetError) {
      return <NotFoundPage />;
    }

    return (
      <div>
        <Helmet
          title={i18n._(messages.title)}
          meta={[{ name: 'description', content: i18n._(messages.description) }]}
        />
        <ChildComponent {...this.props.componentProps} />
      </div>
    );
  }
}

export default AssetDetailData;



// WEBPACK FOOTER //
// ./containers/AssetDetailData/Component.js